import React, { useState, useEffect, useRef } from 'react';
import { FacebookShareButton, WhatsappShareButton } from 'react-share';
import styled from 'styled-components';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { animateScroll as scroll } from 'react-scroll';
import FB from './icons/FB';
import IG from './icons/IG';
import CopyLink from './icons/CopyLink';
import Whatsapp from './icons/Whatsapp';
import BackToTop from './icons/BackToTop';

const FullYear = (new Date()).getFullYear();

const FooterWrapper = styled.div`
  width: 100%;
  background-color: black;

  #CSL_banner_PC {
    max-width: 1200px;
    margin: auto;
  }

  .csl-ad {
    border: 1px solid ${props => props.theme.colors.border};
    box-sizing: border-box;
  }
`;

const SocialMediaWrapper = styled.div`
  padding: 30px;
  box-sizing: border-box;
  color: white;
  text-align: center;
  line-height: 1.5;
  
  a {
    color: ${props => props.theme.colors.primary};
  }

  .small-icon {
    position: relative;
    top: 6px;
    padding-right: 8px;

    svg {
      width: 16px;
    }
  }
`;

const SnsWrapper = styled.div`
  /* display: flex; */
  position: relative;
  color: white;
  font-size: 12px;
  width: calc(100% - 100px);
  max-width: 400px;
  margin: auto;
  box-sizing: border-box;
  padding: 8px;
  padding-bottom: 16px;
  background-color: black;
  /* align-items: center;
  justify-content: space-between; */
  /* border-top: 1px solid white; */

  > button, > div {
    display: inline-block;
    width: calc(100% / 4);
    text-align: center;
  }

  > button {
    background-color: transparent;
    border: none;
    padding: 0px;
    cursor: pointer;
  }
`;

const InfoWrapper = styled.div`
  @media only screen and (min-width: 768px) {
    width: 100%;
    max-width: 1200px;
    margin: auto;
    display: table;
  }
`;

const FBIcon = styled(FB)`
  svg {
    width: 20px;
    fill: #fff;
  }
`;

const IGIcon = styled(IG)`
  svg {
    width: 20px;
    fill: #fff;
  }
`;

const WhatsappIcon = styled(Whatsapp)`
  svg {
    width: 20px;
    fill: #fff;
  }
`;

const CopyLinkIcon = styled(CopyLink)`
  svg {
    width: 20px;
    fill: #fff;
  }
`;

const Credit = styled.div`
  padding: 10px 20px;
  box-sizing: border-box;
  text-align: center;
  background-color: white;
  color: #333;
  font-size: 10px;
`;

const TncPP = styled.div`
  background-color: white;
  font-size: 10px;
  text-align: center;
  padding-bottom: 10px;

  a {
    color: #333;
    text-decoration: none;
  }
`;

const ScrollToTop = styled.div`
  position: fixed;
  right: 16px;
  bottom: 3px;
  cursor: pointer;
`;

const ToolTip = styled.div`
  position: absolute;
  bottom: 100%;
  right: 0;
  color: white;
`;

const StyledBackToTop = styled(BackToTop)`
  svg {
    width: 40px;
    fill: ${props => props.theme.colors.primary};
  }
`;

const AdWrapper = styled.div`
  width: calc(100% - 22px);
  margin: auto;
`;

export default ({ cslExclusive24bit }) => {
  const [shareURL, setShareURL] = useState(window.location.hash);
  const [isInitial, setIsInitial] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [copied, setCopied] = useState(false);
  const toolEl = useRef(null);
  const prevCopied = useRef(false);

  let timerId = 0;

  useEffect(() => {
    function initial() {
      setShareURL(process.env.REACT_APP_BASE_URL);
      window.addEventListener('scroll', () => {
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        setShowBackToTop(scrollTop > 0);
      });

    }

    if(!isInitial) {
      setIsInitial(true);
      initial();
    }

    if (!prevCopied.current && copied) {
      timerId = setTimeout(() => {
        setCopied(false);
        clearTimeout(timerId);
      }, 2000);
    }

  }, [isInitial, copied, timerId]);

  return (
    <FooterWrapper>
      <AdWrapper>
        {!!cslExclusive24bit ? 
        <a href="https://www.hkcsl-5g.com/tc/5g-tariff-plan/?utm_source=moov&utm_medium=web&utm_campaign=banner&utm_content=200326_csl5gtariff" target="_blank" rel="noopener noreferrer">
          <img className="csl-ad mobile" src={`${process.env.REACT_APP_BUILD_URL}/images/site/CSL_banner_M.jpg`} alt="" width="100%" />
          <img id="CSL_banner_PC" className="csl-ad desktop" src={`${process.env.REACT_APP_BUILD_URL}/images/site/CSL_banner_PC.jpg`} alt="" width="100%" />
        </a> : <a href="https://moov.hk/reg/paynow.html" target="_blank" rel="noopener noreferrer">
          <img className="csl-ad mobile" src={`${process.env.REACT_APP_BUILD_URL}/images/site/CSL_banner_M_0629.jpg`} alt="" width="100%" />
          <img id="CSL_banner_PC" className="csl-ad desktop" src={`${process.env.REACT_APP_BUILD_URL}/images/site/CSL_banner_PC_0629.jpg`} alt="" width="100%" />
        </a>}
      </AdWrapper>
      <InfoWrapper className="footer">
        <SocialMediaWrapper>
          <div>想了解更多？立即追蹤MOOV</div>
          <div><FBIcon className="small-icon" /> <a href="https://www.facebook.com/MOOVHK/" target="_blank" rel="noopener noreferrer">MOOV</a></div>
          <div><IGIcon className="small-icon" /> <a href="https://www.instagram.com/moov_music/" target="_blank" rel="noopener noreferrer">moov_music</a></div>
        </SocialMediaWrapper>
        <SnsWrapper>
          <div>分享</div>
          <FacebookShareButton url={shareURL}>
            <FBIcon isShare />
          </FacebookShareButton>
          <WhatsappShareButton url={shareURL}>
            <WhatsappIcon isShare />
          </WhatsappShareButton>
          {!!copied && <ToolTip>已複制</ToolTip>}
          <CopyToClipboard ref={toolEl} text={shareURL} onCopy={() => { setCopied(true); }}>
            <button><CopyLinkIcon isShare /></button>
          </CopyToClipboard>
          <div />
        </SnsWrapper>
      </InfoWrapper>
      <Credit>
        © Moov (Hong Kong) Limited {FullYear === 2020 ? '2020' : `2020 - ${FullYear}`}.著作權所有
      </Credit>
      <TncPP>
        <a href="http://general.moov.hk/tnc/website.html" target="_blank" rel="noopener noreferrer">條款及條件</a> | <a href="http://www.pccw.com/privacy-statement/index.page?locale=zh" target="_blank" rel="noopener noreferrer">私隱政策</a>
      </TncPP>
      {!!showBackToTop && (
        <ScrollToTop onClick={() => { scroll.scrollTo(0); }}>
          <StyledBackToTop />
        </ScrollToTop>
      )}
    </FooterWrapper>
  )
}